import { render, staticRenderFns } from "./AppIntro.vue?vue&type=template&id=2f491ba6&scoped=true&"
import script from "./AppIntro.vue?vue&type=script&lang=js&"
export * from "./AppIntro.vue?vue&type=script&lang=js&"
import style0 from "./AppIntro.vue?vue&type=style&index=0&id=2f491ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f491ba6",
  null
  
)

export default component.exports